import * as actionTypes from '../../../constants/actionTypes';
import { getApiConfig } from '../../../utilities/index';
import { loadingDialog_show, errorBox_Show } from '../../../actions/A_Popups';
import uuid from 'uuid';

const AT = "-" + uuid.v4();

export const ActionTypes = {
  SKU_FILTERS_STONE_FILTERS_BY_TYPE_LOADING: 'SkuFilters/get-stone-filters-by-type-loading' + AT,
  SKU_FILTERS_STONE_FILTERS_BY_TYPE_LOADED: 'SkuFilters/get-stone-filters-by-type-loaded' + AT,
  SKU_FILTERS_GET_BY_GROUP_ID: 'SkuFilters/get-by-group-id' + AT,
  SKU_FILTERS_LOADING: 'SkuFilters/loading' + AT,
  SKU_FILTERS_LOADED: 'SkuFilters/loaded' + AT,
  SKU_FILTERS_SAVING_FOR_ENTITIES: 'SkuFilters/saving-for-entities' + AT,
  SKU_FILTERS_SAVED_FOR_ENTITIES: 'SkuFilters/saved-for-entities' + AT,
  SKU_FILTERS_GET_ALL_GROUPS_LOADED: 'SkuFilters/get-all-groups-loaded' + AT
}


export const getFilters = (page = 0, term = '') => {
  return dispatch => {
    dispatch({ type: actionTypes.SKU_FILTERS_LOADING, payload: term });

    getApiConfig('SkuFilters/GetSkuFilterGroups')
      .post({
        page,
        filterBy: {
          name: term
        }
      })
      .then(response => {
        dispatch({
          type: actionTypes.SKU_FILTERS_LOADED,
          payload: response
        })
      });
  }
};

export const getFilterGroups = (callback) => {
  return (dispatch, getState) => {
    const { filters } = getState();
    const { allFilterGroups } = filters;
    if (allFilterGroups.size) {
      callback(allFilterGroups.toJS());
      return;
    }

    dispatch(loadingDialog_show(true, 'Loading...', 'Loading SKU filter groups...'));

    getApiConfig('SkuFilters/GetSkuFilterGroups')
      .post({})
      .then(response => {
        dispatch({
          type: ActionTypes.SKU_FILTERS_GET_ALL_GROUPS_LOADED,
          payload: response.rows
        });

        dispatch(loadingDialog_show(false));
        callback(response.rows);
      });
  }
}

export const getFilterGroupItems = (filterGroupID, parentID = null) => {
  return dispatch => {
    dispatch(loadingDialog_show(true, 'Loading...', 'Loading filter group items...'));
    dispatch({ type: actionTypes.SKU_FILTERS_ITEMS_LOADING, payload: +filterGroupID });

    getApiConfig('SkuFilters/SkuFilterGroupValues/' + filterGroupID + (parentID ? '/' + parentID : ''))
      .get()
      .then(response => {
        dispatch(loadingDialog_show(false));
        dispatch({ type: actionTypes.SKU_FILTERS_ITEMS_LOADED, payload: response });
      });
  }
}

export const enableFilterGroup = (filterGroupID, enable) => {
  return dispatch => {
    dispatch({ type: actionTypes.SKU_FILTERS_GROUP_ENABLE_UPDATING });

    getApiConfig('SkuFilters/EnableFilterGroup')
      .post({
        filterGroupID,
        enable
      })
      .then(response => {
        dispatch({
          type: actionTypes.SKU_FILTERS_GROUP_ENABLE_UPDATED,
          payload: enable
        })
      });
  }
};

export const expandFilterGroup = (filterGroupID) => {
  return dispatch => dispatch({ type: actionTypes.SKU_FILTERS_GROUP_EXPAND, payload: filterGroupID });
};

export const updateExpandedFilterGroupProp = (propName, value) => {
  return dispatch => dispatch({ type: actionTypes.SKU_FILTERS_GROUP_EXPANDED_UPDATE_PROP, payload: { propName, value } });
}

export const setActiveFilterGroupIcon = icon => {
  return dispatch => dispatch({ type: actionTypes.SKU_FILTERS_GROUP_SET_ACTIVE_GROUP_ICON, payload: icon });
}

export const saveFilterGroup = (group) => {
  return dispatch => {
    if (!group.name || group.name.length < 2) {
      dispatch(errorBox_Show({ text: 'Group name is required.' }));
      return;
    }

    dispatch({ type: actionTypes.SKU_FILTERS_GROUP_SAVING });
    dispatch(loadingDialog_show(true, 'Saving...', 'Saving group...'));

    const formData = new FormData();
    if (group.iconBlob) {
      formData.append('file_icon', group.iconBlob);
    }

    group.iconBlob = null;
    formData.append('json', JSON.stringify(group));
    getApiConfig('SkuFilters/SaveFilterGroup')
      .post(formData)
      .then(response => {
        dispatch({
          type: actionTypes.SKU_FILTERS_GROUP_SAVED,
          payload: response
        });
        dispatch(loadingDialog_show(false));
      });
  }
}


export const tryAddNewFilterGroup = () => ({ type: actionTypes.SKU_FILTERS_GROUP_NEW });

export const cancelFilterGroupEdit = (filterGroupID) => ({
  type: actionTypes.SKU_FILTER_GROUP_CANCEL,
  payload: filterGroupID
});

export const deleteFilterGroup = filterGroupID => {
  return dispatch => {
    dispatch({ type: actionTypes.SKU_FILTER_GROUP_DELETING });
    dispatch(loadingDialog_show(true, 'Deleting...', 'Deleting group...'));

    getApiConfig('SkuFilters/DeleteFilterGroup/' + filterGroupID)
      .delete()
      .then(response => {
        dispatch({ type: actionTypes.SKU_FILTER_GROUP_DELETED });
        dispatch(loadingDialog_show(false));
      });
  }
}

export const enableFilterGroupItem = (filterGroupValueID, enable) => {
  return dispatch => {
    dispatch({ type: actionTypes.SKU_FILTERS_GROUP_ITEM_ENABLE_UPDATING });

    getApiConfig('SkuFilters/EnableFilterGroupValue')
      .post({
        filterGroupValueID,
        enable
      })
      .then(response => {
        dispatch({
          type: actionTypes.SKU_FILTERS_GROUP_ITEM_ENABLE_UPDATED,
          payload: enable
        })
      });
  }
};

export const updateFilterGroupItemsOrder = (idx, dx) => {
  return (dispatch, getState) => {
    const { filters } = getState();
    if (idx + dx < 0 || idx + dx >= filters.filterGroupItems.size)
      return;

    const ids = [];
    for (let i = 0; i < filters.filterGroupItems.size; i++)
      ids.push({ id: filters.filterGroupItems.getIn([i, 'id']), order: i });

    let t = ids[idx].id;
    ids[idx].id = ids[idx + dx].id;
    ids[idx + dx].id = t;

    const idWithOrder = {};
    ids.forEach(_ => idWithOrder[_.id] = _.order);

    dispatch(loadingDialog_show(true, 'Saving...', 'Saving filter group items order...'));
    dispatch({ type: actionTypes.SKU_FILTERS_GROUP_ITEM_ORDER_UPDATING })

    getApiConfig('SkuFilters/UpdateFilterGroupValuesOrder')
      .post(idWithOrder)
      .then(result => {
        dispatch(loadingDialog_show(false));
        dispatch({ type: actionTypes.SKU_FILTERS_GROUP_ITEM_ORDER_UPDATED })
      });
  }
}

export const expandFilterGroupItem = (filterGroupItemID) => (
  { type: actionTypes.SKU_FILTERS_GROUP_ITEM_EXPAND, payload: filterGroupItemID }); 

export const cancelFilterGroupItemEdit = (filterGroupItemID) => ({
  type: actionTypes.SKU_FILTER_GROUP_ITEM_CANCEL,
  payload: filterGroupItemID
})

export const getAllFilterGroupsAndValues = (includeDisabled = false) => {
  return dispatch => {
    getApiConfig("SkuFilters/GetAllFilterGroupsAndValues?includeDisabled=" + includeDisabled)
      .get()
      .then(response => {
        dispatch({
          type: actionTypes.SKU_FILTER_GROUP_LOAD_WITH_VALUES,
          payload: {
            filterGroups: response
          }
        });
      });
  }
}

export const updateExpandedFilterGroupItemProp = (propName, value) => {
  return dispatch => dispatch({ type: actionTypes.SKU_FILTERS_GROUP_ITEM_EXPANDED_UPDATE_PROP, payload: { propName, value } });
}

export const saveFilterGroupItem = (groupItem) => {
  return dispatch => {
    if (!groupItem.displayText || groupItem.displayText.length < 2) {
      dispatch(errorBox_Show({text: 'DisplayText is required.'}));
      return;
    }

    dispatch({type: actionTypes.SKU_FILTERS_GROUP_ITEM_SAVING});
    dispatch(loadingDialog_show(true, 'Saving...', 'Saving item...'));

    const formData = new FormData();
    if (groupItem.iconBlob) {
      formData.append('file_icon', groupItem.iconBlob);
    }

    groupItem.iconBlob = null;
    formData.append('json', JSON.stringify(groupItem));
    getApiConfig('SkuFilters/SaveFilterGroupValue')
      .post(formData)
      .then(response => {
        dispatch({
          type: actionTypes.SKU_FILTERS_GROUP_ITEM_SAVED,
          payload: response
        });
        dispatch(loadingDialog_show(false));
      });
  }
}


export const tryAddNewFilterGroupItem = (filterGroupID) => ({type: actionTypes.SKU_FILTERS_GROUP_ITEM_NEW, payload: filterGroupID});

